export function dataInRequest(params = {}) {
  return {
    type: '@operacaoLimpezaTag/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@operacaoLimpezaTag/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoLimpezaTag/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@operacaoLimpezaTag/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@operacaoLimpezaTag/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@operacaoLimpezaTag/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@operacaoLimpezaTag/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@operacaoLimpezaTag/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoLimpezaTag/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoLimpezaTag/RECORD_FILTERING',
    payload: { params },
  };
}
